import React, { useEffect, useState } from "react";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import CandidateJobLayout from "../commonlayouts/candidatejoblayout.js";
import Axios from "axios";
import {
  GetCandidateById,
  GetJobRoles,
  GetCourseInfo,
  GetJobPosts,
  AddCandidateSubmissions,
  SaveCandidateRecordedAudio,
  GetListOfUsersWithAdminByEmployeeID,
  GetListOfVendorsByEmployeeID,
  GetCandidateSubmission,
  GetDocumentTypes,
  GetCandidateByGuid,
  UpdateCandidateSubmissions,
  DeleteCandidateSubmission,
} from "../apiconstants/constants";
import { useLocation, useNavigate } from "react-router-dom";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Modal from "react-bootstrap/Modal";
import LoadingSpinner from "../helpers/loadingspinner";
import { useCountry } from "../contexts/countrycodecontext.js";
import { useForm } from "react-hook-form";
import { Accordion, Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import mammoth from "mammoth";
import axios from "axios";
import Select from "react-select";
import ReactQuill from "react-quill";
import DOMPurify from "dompurify";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ViewAppliedCandidateDetailsbyId = () => {
  let query = useQuery();
  const id = query.get("id");          // from ViewAppliedCandidatesforJob
  const jobPostID = query.get("jobpost");
  const guid = id;                     // API expects candidate guid

  const { selectedCountry } = useCountry();
  const userguid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const email = localStorage.getItem("email");
  const roleID = localStorage.getItem("roleID");
  const token = localStorage.getItem("jwtToken");

  let Guid = "";
  if (roleID == 3) {
    Guid = employerGuid;
  } else {
    Guid = userguid;
  }

  const navigate = useNavigate();

  // ======== STATE =========
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [jobRoles, setJobRoles] = useState([]);
  const [qualifications, setQualifications] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [showModal, setShowModal] = useState(false);      // resume preview
  const [modalContent, setModalContent] = useState({ title: "", url: "" });
  const [showModal1, setShowModal1] = useState(false);    // documents preview
  const [isLoading, setIsLoading] = useState(false);

  const [showSubmissionForm, setShowSubmissionForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);

  const [selectedJobTitleId, setSelectedJobTitleId] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [submittedBy, setSubmittedBy] = useState("");
  const [skills, setSkills] = useState([{ Skill: "", YearsOfExp: "", Rating: "" }]);

  const [showAssessmentModal, setShowAssessmentModal] = useState(false);
  const [assessmentMode, setAssessmentMode] = useState(""); // "link" or "file"
  const [assessmentFile, setAssessmentFile] = useState(null);

  const [audioValue, setAudioValue] = useState("");
  const [audioFile, setAudioFile] = useState("");

  const [years, setYears] = useState("");
    const [months, setMonths] = useState("");
 const handleExperienceChange = (y, m) => {
  setYears(y);
  setMonths(m);

  let expText = "";

  if (y && !m) {
    expText = `${y} Years`;
  } else if (!y && m) {
    expText = `${m} Months`;
  } else if (y && m) {
    expText = `${y} Years ${m} Months`;
  } else {
    expText = "";
  }

  setValue("experience", expText);
};

  const [vendorData, setVendorData] = useState([]);
  const [selectedDocType, setSelectedDocType] = useState(null);
  const [documents, SetDocuments] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [jobPosts, setJobPosts] = useState([]);
  const [submissionData, setSubmissionData] = useState({});
  const [currentSubmissionGuid, setCurrentSubmissionGuid] = useState(null);

  const { register, handleSubmit, reset, watch, setValue, formState: { errors } } =
    useForm({
      defaultValues: {
        payRate: "",
        BillRate: "",
        jobRole: "",
        VendorGuid: "",
        jobPost: "",
        experience: "",
        clientStatus: "",
        documents: [],
        technicalSkill: "",
        ProfileSummery: "",
        customAssessmentLink: "",
        SkillMetrics: "",
        AvailabilityToInterview: "",
        AvailabilityToJoin: "",
        WillingToRelocate: "",
        Tworefrencesfromrecentproject: "",
        SubmittedBy: "",
        Comments: "",
        workMode: "",
      },
    });

  const workmode = [
    { statusID: "1", statusName: "Work from Home" },
    { statusID: "2", statusName: "Work from Office" },
    { statusID: "3", statusName: "Hybrid" },
  ];

  const documentLabels = {
    FileUrl: "Resume",
    VisaCopyUrl: "Visa Copy",
    DrivingLicenceUrl: "Driving Licence",
    PassportURL: "Passport",
    I94File: "I-94",
    RTR_PDFDoc: "RTR_PDF",
    Resume_Insights_Pdfdoc: "Resume_Insights_Pdf",
    OthersDoc: "Others",
  };

  // ======== HELPERS =========
  const safeValue = (value) =>
    value === null ||
    value === undefined ||
    value === "null" ||
    value === "undefined"
      ? ""
      : value;

  const capitalizeFirstLetter = (string) =>
    string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : "";

  const getExperienceText = (experience) => {
    if (!experience) return "";
    return experience.toLowerCase().includes("years") ? experience : `${experience} years`;
  };

  const getJobRoleName = (id) => {
    const jobRole = jobRoles.find((role) => role.jobRoleId == id);
    return jobRole ? jobRole.jobRole : "";
  };

  const getQualificationName = (id) => {
    const qualification = qualifications.find((q) => q.qualificationID == id);
    return qualification ? qualification.courseName : "";
  };

  const handleShowModal = (title, url) => {
    setModalContent({ title, url });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal1 = async (docTypeKey, file) => {
    if (!file) return;

    let fileName = "";
    let blobUrl = "";

    if (file instanceof File) {
      fileName = file.name.toLowerCase();
      blobUrl = URL.createObjectURL(file);
    } else if (typeof file === "string") {
      fileName = file.split("/").pop().toLowerCase();
      blobUrl = file;
    } else {
      console.error("Unknown file type");
      return;
    }

    if (fileName.endsWith(".docx")) {
      if (file instanceof File) {
        try {
          const arrayBuffer = await file.arrayBuffer();
          const { value } = await mammoth.convertToHtml({ arrayBuffer });
          setModalContent({
            title: documentLabels[docTypeKey] || docTypeKey,
            html: value,
            url: null,
            file: file,
          });
        } catch (error) {
          console.error("DOCX preview error", error);
          setModalContent({
            title: documentLabels[docTypeKey] || docTypeKey,
            html: "<p>Failed to render DOCX preview.</p>",
            url: null,
            file: file,
          });
        }
      } else if (typeof file === "string") {
        setModalContent({
          title: documentLabels[docTypeKey] || docTypeKey,
          html: null,
          url: file,
          file: null,
        });
      } else {
        setModalContent({
          title: documentLabels[docTypeKey] || docTypeKey,
          html: "<p>Cannot preview this DOCX file.</p>",
          url: null,
          file: null,
        });
      }
    } else {
      setModalContent({
        title: documentLabels[docTypeKey] || docTypeKey,
        html: null,
        url: file,
        file: null,
      });
    }

    setShowModal1(true);
  };

  const handleCloseModal1 = () => {
    setShowModal1(false);
  };

  const handleDownload = (url) => {
    if (!url) return;
    const fileExtension = url.split(".").pop().toLowerCase();
    const link = document.createElement("a");
    link.href = url;

    if (["pdf", "html", "htm"].includes(fileExtension)) {
      link.target = "_blank";
    } else {
      link.setAttribute("download", "");
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const renderAttachment = (url, file, html) => {
    if (html) {
      return (
        <div
          style={{ maxHeight: "500px", overflowY: "auto" }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      );
    }

    let name = "";
    if (file && file.name) {
      name = file.name.toLowerCase();
    } else if (typeof url === "string") {
      name = url.split("/").pop()?.toLowerCase() || "";
    } else {
      return <div>File not found or unsupported format.</div>;
    }

    if (!url && !file) {
      return <div>File not found.</div>;
    }

    const fileUrl =
      typeof url === "string"
        ? url
        : file
        ? URL.createObjectURL(file)
        : null;

    if (!fileUrl) {
      return <div>File not found.</div>;
    }

    if (name.endsWith(".pdf")) {
      return (
        <iframe
          src={fileUrl}
          style={{ width: "100%", height: "500px", border: "none" }}
          title="PDF Preview"
        />
      );
    }

    if (name.endsWith(".jpg") || name.endsWith(".jpeg") || name.endsWith(".png")) {
      return <img src={fileUrl} alt="preview" style={{ maxWidth: "100%" }} />;
    }

    if (name.endsWith(".html") || name.endsWith(".htm")) {
      return (
        <iframe
          src={fileUrl}
          title="HTML Preview"
          style={{ width: "100%", height: "500px", border: "none" }}
        />
      );
    }

    if (name.endsWith(".docx")) {
      if (typeof fileUrl === "string" && fileUrl.startsWith("https")) {
        return (
          <iframe
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              fileUrl
            )}`}
            title="DOCX Preview"
            style={{ width: "100%", height: "500px", border: "none" }}
          />
        );
      } else {
        return (
          <div>
            <p>
              DOCX preview not supported for local files.{" "}
              <a href={fileUrl} target="_blank" rel="noreferrer">
                Download
              </a>
            </p>
          </div>
        );
      }
    }

    return (
      <div>
        <p>
          Preview not supported for this file type.{" "}
          <a href={fileUrl} target="_blank" rel="noreferrer">
            Download
          </a>
        </p>
      </div>
    );
  };

  const handleRemoveFile = async (docTypeKey) => {
    const fileToDelete = uploadedFiles[docTypeKey];
    if (!fileToDelete) return;

    const confirmDelete = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to remove this document?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
    });

    if (!confirmDelete.isConfirmed) return;

    try {
      const updatedFiles = { ...uploadedFiles };
      updatedFiles[docTypeKey] = null;
      setUploadedFiles(updatedFiles);

      Swal.fire({
        icon: "success",
        title: "Removed!",
        text: `${docTypeKey} has been cleared.`,
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error removing file:", error);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Unable to clear the document. Please try again.",
      });
    }
  };

  

  const handleChangeSkill = (index, field, value) => {
    const updated = [...skills];
    updated[index][field] = value;
    setSkills(updated);
    setValue("SkillMetrics", JSON.stringify(updated));
  };

  const handleAddSkill = () => {
    setSkills([...skills, { Skill: "", YearsOfExp: "", Rating: "" }]);
  };

  const handleDeleteSkill = (index) => {
    const updated = skills.filter((_, i) => i !== index);
    setSkills(updated);
    setValue("SkillMetrics", JSON.stringify(updated));
  };

  const saveCandidateAudio = async (candidateGuid, candidateName, audioFileParam, audioValueParam) => {
    const audioForm = new FormData();
    audioForm.append("Guid", candidateGuid);
    audioForm.append("CandidateName", candidateName);
    audioForm.append("Audio", audioFileParam);
    audioForm.append("AudioUrl", audioFileParam?.name || "");
    audioForm.append("FileId", audioValueParam || "");

    try {
      await Axios.post(SaveCandidateRecordedAudio.APIURL, audioForm, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (err) {
      console.error("Save audio failed:", err);
    }
  };

  // ======== API CALLS =========
  const fetchSubmissions = async () => {
    try {
      const url = GetCandidateByGuid.APIURL;
      const payload = { guid: guid };
      const res = await Axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSubmissions(res.data?.submissions || []);
    } catch (err) {
      console.error("Error fetching submissions:", err);
    }
  };

  const GetUsersList = async () => {
    try {
      setIsLoading(true);
      const GetapiUrl =
        GetListOfUsersWithAdminByEmployeeID.APIURL + `?EmployeeGuid=${Guid}`;

      const result = await Axios.get(GetapiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const filteredusers = result.data?.filter((user) =>
        user.countryMappings?.includes(selectedCountry)
      );
      setUsersList(filteredusers || []);
    } catch (error) {
      console.log("Error" + error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSubmissionById = async (submissionId) => {
    try {
      if (!submissionId) {
        console.error("❌ submissionId is undefined.");
        return;
      }

      const url = `${GetCandidateSubmission.APIURL}?submissionGuid=${submissionId}`;
      const res = await Axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data || {};
      setSubmissionData(data);

    if (res.data?.experience) {
  const exp = res.data.experience.match(/(\d+)?\s*Years?\s*(\d+)?\s*Months?/i);

  const y = exp?.[1] || "";
  const m = exp?.[2] || "";

  setYears(y);
  setMonths(m);

  let expText = "";
  if (y && !m) expText = `${y} Years`;
  if (!y && m) expText = `${m} Months`;
  if (y && m) expText = `${y} Years ${m} Months`;

  setValue("experience", expText);
}


      setCurrentSubmissionGuid(data.submissionGuid);
      setSelectedJobTitleId(data.jobTitleID || "");
      setSubmittedBy(data.submittedBy || "");
      setValue("SubmittedBy", data.submittedBy || "");
      setValue("Comments", data.comments || "");

      reset({
        payRate: data.payRate
          ? data.payRate.replace(/rs\.?/i, "").replace(/\$/g, "").replace(/[^\d]/g, "")
          : "",
        BillRate: data.billRate
          ? data.billRate.replace(/rs\.?/i, "").replace(/\$/g, "").replace(/[^\d]/g, "")
          : "",
        jobRole: data.jobRole || "",
        VendorGuid: data.vendorGuid || "",
        jobPost: data.jobTitleID || "",
        experience: data.experience || "",
        clientStatus: data.clientStatus || "Submitted",
        technicalSkill: data.technicalSkill || "",
        workMode: data.workMode || "",
        ProfileSummery: data.profileSummery || "",
        SubmittedBy: data.SubmittedBy || "",
        Comments: data.comments || "",
        AvailabilityToJoin: data.availabilityToJoin || data.AvailabilityToJoin || "",
        AvailabilityToInterview:
          data.availabilityToInterview || data.AvailabilityToInterview || "",
        WillingToRelocate: data.willingToRelocate?.toString(),
        Tworefrencesfromrecentproject:
          data.tworefrencesfromrecentproject || data.tworefrencesfromrecentproject || "",
        documents: [],
      });

      if (data.skillMetrics) {
        try {
          setSkills(JSON.parse(data.skillMetrics));
        } catch {
          setSkills([{ Skill: "", YearsOfExp: "", Rating: "" }]);
        }
      } else {
        setSkills([{ Skill: "", YearsOfExp: "", Rating: "" }]);
      }

      if (data.customAssessmentLink) {
        setAssessmentMode("link");
        setValue("customAssessmentLink", data.customAssessmentLink);
      } else if (data.customAssessmentFile) {
        setAssessmentMode("file");
        setAssessmentFile(data.customAssessmentFile);
      } else {
        setAssessmentMode("");
        setAssessmentFile(null);
      }

      if (data.jobRole && data.vendorGuid) {
        await fetchJobPosts(data.jobRole, data.vendorGuid);
      }

      setUploadedFiles({
        Resume:
          data.fileUrl && data.fileUrl.trim() !== ""
            ? data.fileUrl
            : data.resume && data.resume.trim() !== ""
            ? data.resume
            : null,
        RTR_PDF:
          data.rtR_PDFDoc && data.rtR_PDFDoc.trim() !== ""
            ? data.rtR_PDFDoc
            : data.rtR_PDF && data.rtR_PDF.trim() !== ""
            ? data.rtR_PDF
            : null,
        Resume_Insights_Pdf:
          data.resume_Insights_Pdfdoc && data.resume_Insights_Pdfdoc.trim() !== ""
            ? data.resume_Insights_Pdfdoc
            : data.resume_Insights_Pdf && data.resume_Insights_Pdf.trim() !== ""
            ? data.resume_Insights_Pdf
            : null,
        Others:
          data.othersDoc && data.othersDoc.trim() !== ""
            ? data.othersDoc
            : data.others && data.others.trim() !== ""
            ? data.others
            : null,
        VisaCopy:
          data.visaCopyUrl && data.visaCopyUrl.trim() !== ""
            ? data.visaCopyUrl
            : data.visaCopy && data.visaCopy.trim() !== ""
            ? data.visaCopy
            : null,
        DrivingLicence:
          data.drivingLicenceUrl && data.drivingLicenceUrl.trim() !== ""
            ? data.drivingLicenceUrl
            : data.drivingLicence && data.drivingLicence.trim() !== ""
            ? data.drivingLicence
            : null,
        Passport:
          data.passportURL && data.passportURL.trim() !== ""
            ? data.passportURL
            : data.passport && data.passport.trim() !== ""
            ? data.passport
            : null,
        I94:
          data.i94File && data.i94File.trim() !== ""
            ? data.i94File
            : data.i94 && data.i94.trim() !== ""
            ? data.i94
            : null,
      });
    } catch (err) {
      console.error("Error fetching submission:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch submission details. Please try again.",
      });
    }
  };

  const fetchJobRoles = async () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
    try {
      const response = await Axios.get(getApiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setJobRoles(response.data);
    } catch (error) {
      console.error("Error fetching job roles", error);
    }
  };

  const fetchQualifications = async () => {
    const getApiUrl = GetCourseInfo.APIURL;
    try {
      const response = await Axios.get(getApiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setQualifications(response.data);
    } catch (error) {
      console.error("Error fetching qualifications", error);
    }
  };

  const GetCandidateDetails = async () => {
    const GetapiUrl = GetCandidateById.APIURL;
    const params = { guid: guid };
    try {
      const result = await Axios.post(GetapiUrl, params, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCandidateDetails(result.data);

      setUploadedFiles({
        FileUrl: result.data?.fileUrl || null,
        VisaCopyUrl: result.data?.visaCopyUrl || null,
        DrivingLicenceUrl: result.data?.drivingLicenceUrl || null,
        PassportURL: result.data?.passportURL || null,
        I94File: result.data?.i94File || null,
        RTR_PDFDoc: result.data?.rtR_PDFDoc || null,
        Resume_Insights_Pdfdoc: result.data?.resume_Insights_Pdfdoc || null,
        OthersDoc: result.data?.othersDoc || null,
      });
    } catch (error) {
      console.error("Error fetching candidate details:", error);
    }
  };

  const GetVendorsList = async () => {
    try {
      setIsLoading(true);
      const GetapiUrl =
        GetListOfVendorsByEmployeeID.APIURL +
        `?UserGuid=${Guid}&CountryID=${selectedCountry}`;

      const result = await Axios.get(GetapiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setVendorData(result.data);
    } catch (error) {
      console.log("Error" + error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchcodocumenttypes = async () => {
    const GetapiUrl = GetDocumentTypes.APIURL;
    try {
      const response = await fetch(GetapiUrl);
      const json = await response.json();
      SetDocuments(json);
    } catch (error) {
      console.error("Error fetching document types", error);
    }
  };

  const fetchJobPosts = async (jobRoleId, vendorGuid) => {
    setIsLoading(true);
    try {
      const response = await Axios.get(
        `${GetJobPosts.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const filteredPosts = response.data.filter(
        (post) =>
          post.jobRoleID == jobRoleId &&
          post.vGuid == vendorGuid &&
          post.status === "Active"
      );

      setJobPosts(filteredPosts);
    } catch (error) {
      console.error("Error fetching job posts", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteSubmission = async (submissionId) => {
    try {
      setIsLoading(true);
      const result = await Axios.delete(
        `${DeleteCandidateSubmission.APIURL}?submissionGuid=${submissionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (result.data === "Deleted successfully.") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Deleted successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        fetchSubmissions();
        setShowModal(false);
      }
    } catch (error) {
      console.log("Error", error);
    } finally {
      setIsLoading(false);
    }
  };

  // ======== FORM SUBMIT =========
  const onSubmit = async (data) => {
    try {
      setIsLoading(true);

      const formData = new FormData();
      const finalJobTitleId = data.jobPost || selectedJobTitleId;

      if (isEditing && currentSubmissionGuid) {
        formData.append("SubmissionGuid", currentSubmissionGuid);
      } else {
        formData.append(
          "SubmissionGuid",
          "00000000-0000-0000-0000-000000000000"
        );
      }

      formData.append("CandidateGuid", guid);
      formData.append("CandidateID", candidateDetails?.candidatesID || "");
      formData.append("JobRoleID", data.jobRole || "");
      formData.append("VendorGuid", data.VendorGuid || "");
      formData.append("TechnicalSkill", data.technicalSkill || "");
      formData.append("Experience", data.experience || "");
      formData.append("WorkMode", data.workMode || "");
      formData.append("ProfileSummery", data.ProfileSummery || "");
      formData.append("JobTitleID", finalJobTitleId || "");
      formData.append("ClientStatus", data.clientStatus || "");
      formData.append(
        "SubmittedBy",
        data.SubmittedBy || submittedBy || email
      );
      formData.append(
        "SkillMetrics",
        data.SkillMetrics || JSON.stringify(skills || [])
      );
      formData.append(
        "AvailabilityToInterview",
        data.AvailabilityToInterview || ""
      );
      formData.append("AvailabilityToJoin", data.AvailabilityToJoin || "");
      formData.append("WillingToRelocate", data.WillingToRelocate);
      formData.append(
        "TwoReferencesFromRecentProject",
        data.Tworefrencesfromrecentproject ||
          data.TwoReferencesFromRecentProject ||
          ""
      );
      formData.append("CustomAssessmentLink", data.customAssessmentLink || "");
      formData.append("comments", data.Comments || "");
      formData.append("CreatedBy", email);

      const formatRate = (value, isUSD) => {
        if (!value) return "";
        const trimmedValue = value.toString().trim();
        const hasCurrency = /(\$|rs\.?|inr|usd)/i.test(trimmedValue);
        if (hasCurrency) return trimmedValue;
        return isUSD ? `$${trimmedValue}` : `Rs.${trimmedValue}`;
      };

      formData.append(
        "PayRate",
        formatRate(data.payRate, selectedCountry == 2)
      );
      formData.append(
        "BillRate",
        formatRate(data.BillRate, selectedCountry == 2)
      );

      const appendFilePair = (labelKey, binaryKey, localKey) => {
        let file = uploadedFiles[localKey];

        if (file instanceof File) {
          formData.append(labelKey, file.name);
          formData.append(binaryKey, file, file.name);
          return;
        }

        if (typeof file === "string" && file.trim() !== "") {
          const filename = file.split("/").pop();
          formData.append(labelKey, filename);
          formData.append(binaryKey, file);
          return;
        }

        if (isEditing && submissionData) {
          const previousFiles = {
            Resume: submissionData.fileUrl,
            RTR_PDF: submissionData.rtR_PDFDoc,
            Resume_Insights_Pdf: submissionData.resume_Insights_Pdfdoc,
            Others: submissionData.othersDoc,
            VisaCopy: submissionData.visaCopyUrl,
            DrivingLicence: submissionData.drivingLicenceUrl,
            Passport: submissionData.passportURL,
            I94: submissionData.i94File,
          };

          const existingUrl = previousFiles[labelKey];
          if (existingUrl && existingUrl.trim() !== "") {
            const filename = existingUrl.split("/").pop();
            formData.append(labelKey, filename);
            formData.append(binaryKey, existingUrl);
            return;
          }
        }

        formData.append(labelKey, "");
        formData.append(binaryKey, "");
      };

      appendFilePair("Resume", "FileUrl", "Resume");
      appendFilePair("RTR_PDF", "RTR_PDFDoc", "RTR_PDF");
      appendFilePair(
        "Resume_Insights_Pdf",
        "Resume_Insights_Pdfdoc",
        "Resume_Insights_Pdf"
      );
      appendFilePair("Others", "OthersDoc", "Others");
      appendFilePair("VisaCopy", "VisaCopyUrl", "Visa Copy");
      appendFilePair(
        "DrivingLicence",
        "DrivingLicenceUrl",
        "Driving Licence"
      );
      appendFilePair("Passport", "PassportURL", "Passport");
      appendFilePair("I94", "I94File", "I-94");

      const apiurl = isEditing
        ? UpdateCandidateSubmissions.APIURL
        : AddCandidateSubmissions.APIURL;

      const response = await axios.post(apiurl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      if (assessmentMode === "file" && assessmentFile) {
        await saveCandidateAudio(
          currentSubmissionGuid,
          candidateDetails?.fullName,
          assessmentFile,
          audioValue
        );
      }

      if (response.data.message === "Record created successfully") {
        setShowSubmissionForm(false);
        fetchSubmissions();
        await Swal.fire({
          title: "✅ Success!",
          text: "Submission created successfully.",
          icon: "success",
          confirmButtonColor: "#28a745",
        });
        reset();
        setUploadedFiles({});
        setSelectedDocType("");
      } else if (response.data.message === "Record updated successfully") {
        setShowSubmissionForm(false);
        fetchSubmissions();
        await Swal.fire({
          title: "✅ Success!",
          text: "Submission updated successfully.",
          icon: "success",
          confirmButtonColor: "#28a745",
        });
        reset();
        setUploadedFiles({});
        setSelectedDocType("");
      } else {
        await Swal.fire({
          title: "⚠️ Error",
          text: "Something went wrong while saving the submission.",
          icon: "error",
          confirmButtonColor: "#dc3545",
        });
      }
    } catch (error) {
      console.error("❌ API Error:", error);
      await Swal.fire({
        title: "❌ Error",
        text:
          error.response?.data?.message ||
          "Failed to submit candidate data.",
        icon: "error",
        confirmButtonColor: "#dc3545",
      });
    } finally {
      setIsLoading(false);
    }
  };

  // ======== EFFECTS =========
  useEffect(() => {
    const initializeData = async () => {
      try {
        await fetchJobRoles();
        await fetchQualifications();
        await GetCandidateDetails();
        await GetVendorsList();
        await fetchcodocumenttypes();
        await fetchSubmissions();
        await GetUsersList();
      } catch (error) {
        console.error("Error initializing data:", error);
      }
    };

    initializeData();
  }, [selectedCountry]);

  const selectedJobRole = watch("jobRole");
  const selectedVendorGuid = watch("VendorGuid");

  useEffect(() => {
    if (selectedJobRole && selectedVendorGuid) {
      fetchJobPosts(parseInt(selectedJobRole), selectedVendorGuid);
    } else {
      setJobPosts([]);
    }
  }, [selectedJobRole, selectedVendorGuid]);

  // ========= RENDER ==========
  return (
    <ConsultantLayout>
      <style>
        {`.custom-modal-dialog {
  max-width: 90vw !important;
}
.custom-modal-dialog .modal-content {
  height: 90vh;
  display: flex;
  flex-direction: column;
}
.custom-modal-dialog .modal-header,
.custom-modal-dialog .modal-footer {
  flex-shrink: 0;
}
.custom-modal-body {
  flex-grow: 1;
  overflow-y: auto;
  max-height: calc(90vh - 120px);
  padding-right: 12px;
}`}
      </style>

      {candidateDetails ? (
        <div className="container-fluid">
          <CandidateJobLayout
            title="Applied Candidate Details"
            candidateGuid={guid}
            fullName={candidateDetails?.fullName}
            email={candidateDetails?.email}
          />
          <hr />

          <Accordion defaultActiveKey="0" className="mt-1">
            {/* ========== CANDIDATE DETAILS ACCORDION ========== */}
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <i className="fa fa-user text-info mr-2"></i> Candidate Details
              </Accordion.Header>
              <Accordion.Body>
                <div
                  className="card shadow-lg mt-2 pl-5 pr-5 pt-2"
                  style={{ border: "none" }}
                >
                  <div className="row mt-2">
                    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="tooltip-fullName">Full Name</Tooltip>
                        }
                      >
                        <p className="text-para">
                          <i className="fa fa-user icons"></i>{" "}
                          {candidateDetails.fullName}
                        </p>
                      </OverlayTrigger>

                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="tooltip-email">Email</Tooltip>
                        }
                      >
                        <p className="text-para">
                          <i className="fa fa-envelope icons"></i>{" "}
                          {candidateDetails.email}
                        </p>
                      </OverlayTrigger>

                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="tooltip-mobileNumber">
                            Mobile Number
                          </Tooltip>
                        }
                      >
                        <p className="text-para">
                          <i className="fa fa-phone icons"></i>{" "}
                          {candidateDetails.mobileNumber}
                        </p>
                      </OverlayTrigger>

                      {candidateDetails.gender &&
                        candidateDetails.gender !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-gender">Gender</Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-venus-mars icons"></i>{" "}
                              {candidateDetails.gender}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.address &&
                        candidateDetails.address !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-address">Address</Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-map-marker icons"></i>{" "}
                              {candidateDetails.address}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.dob &&
                        candidateDetails.dob !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-dob">
                                Date of Birth
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-birthday-cake icons"></i>{" "}
                              {candidateDetails.dob}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.maritalStatus &&
                        candidateDetails.maritalStatus !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-maritalStatus">
                                Marital Status
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-heart icons"></i>{" "}
                              {capitalizeFirstLetter(
                                candidateDetails.maritalStatus
                              )}
                            </p>
                          </OverlayTrigger>
                        )}

                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="tooltip-experience">
                            Experience
                          </Tooltip>
                        }
                      >
                        <p className="text-para">
                          <i className="fa fa-briefcase icons"></i>{" "}
                          {getExperienceText(candidateDetails.experience)}
                        </p>
                      </OverlayTrigger>

                      {candidateDetails.technicalSkill &&
                        candidateDetails.technicalSkill !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-technicalSkill">
                                Technical Skill
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-cogs icons"></i>{" "}
                              {candidateDetails.technicalSkill}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.highestEducation &&
                        candidateDetails.highestEducation !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-education">
                                Highest Education
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-graduation-cap icons"></i>{" "}
                              {candidateDetails.highestEducation}
                            </p>
                          </OverlayTrigger>
                        )}

                      {selectedCountry == 2 &&
                        candidateDetails.workAuthorizationandValidity &&
                        candidateDetails.workAuthorizationandValidity !==
                          "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-workAuth">
                                Work Authorization and Validity
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-cogs icons"></i>{" "}
                              {
                                candidateDetails.workAuthorizationandValidity
                              }
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.candidateType &&
                        candidateDetails.candidateType !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-workMode">
                                Candidate Type
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fas fa-hourglass-half icons"></i>{" "}
                              {safeValue(candidateDetails.candidateType)}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.employerName &&
                        candidateDetails.employerName !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-empName">
                                Employer Name
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-cogs icons"></i>{" "}
                              {candidateDetails.employerName}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.ssn &&
                        candidateDetails.ssn !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-ssn">SSN</Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-building icons"></i>{" "}
                              {candidateDetails.ssn}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.passportNo &&
                        candidateDetails.passportNo !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-passport">
                                Passport Number
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-id-card icons"></i>{" "}
                              {candidateDetails.passportNo}
                            </p>
                          </OverlayTrigger>
                        )}
                    </div>

                    <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                      {candidateDetails.createdBy &&
                        candidateDetails.createdBy !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-createdBy">
                                Created By
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-user icons"></i>{" "}
                              {candidateDetails.createdBy}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.priority &&
                        candidateDetails.priority !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-priority">
                                Priority
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-building icons"></i>{" "}
                              {candidateDetails.priority}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.profileSummery &&
                        candidateDetails.profileSummery !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-profileSummery">
                                Profile Summary
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-info-circle icons"></i>{" "}
                              {candidateDetails.profileSummery}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.jobRole &&
                        candidateDetails.jobRole !== 0 &&
                        candidateDetails.jobRole !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-jobRole">Job Role</Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-briefcase icons"></i>{" "}
                              {getJobRoleName(candidateDetails.jobRole)}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.qualificationID &&
                        candidateDetails.qualificationID !== 0 &&
                        candidateDetails.qualificationID !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-qualification">
                                Qualification
                              </Tooltip>
                            }
                          >
                            <p className="text-para">
                              <i className="fa fa-graduation-cap icons"></i>{" "}
                              {getQualificationName(
                                candidateDetails.qualificationID
                              )}
                            </p>
                          </OverlayTrigger>
                        )}

                      {candidateDetails.linkedInUrl &&
                        candidateDetails.linkedInUrl !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-linkedin">
                                LinkedIn Url
                              </Tooltip>
                            }
                          >
                            <a
                              href={
                                candidateDetails.linkedInUrl?.startsWith(
                                  "http"
                                )
                                  ? candidateDetails.linkedInUrl
                                  : `https://${candidateDetails.linkedInUrl}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <p className="text-para">
                                <i className="fa fa-graduation-cap icons mr-1"></i>
                                {candidateDetails.linkedInUrl}
                              </p>
                            </a>
                          </OverlayTrigger>
                        )}

                      {(candidateDetails.resume ||
                        candidateDetails.visaCopy ||
                        candidateDetails.drivingLicence) && (
                        <h2
                          className=""
                          style={{
                            color: "#00a7ac",
                            marginLeft: "10px",
                            marginBottom: "2",
                            marginTop: "0",
                          }}
                        >
                          Attachments
                        </h2>
                      )}

                      {candidateDetails.resume &&
                        candidateDetails.resume !== "null" && (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-resume">Resume</Tooltip>
                            }
                          >
                            <p className="text-para">
                              <a
                                href="#"
                                style={{ fontSize: 18 }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleShowModal(
                                    "Resume",
                                    candidateDetails.fileUrl
                                  );
                                }}
                              >
                                <i className="fa fa-file-alt icons"></i> View
                                Resume
                              </a>
                              &nbsp;|&nbsp;
                              <a
                                href="#"
                                style={{ fontSize: 18 }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDownload(
                                    candidateDetails.fileUrl
                                  );
                                }}
                              >
                                <i className="fa fa-download icons"></i>{" "}
                                Download Resume
                              </a>
                            </p>
                          </OverlayTrigger>
                        )}

                      <Modal
                        show={showModal}
                        onHide={handleCloseModal}
                        size="lg"
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{modalContent.title}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {renderAttachment(modalContent.url)}
                        </Modal.Body>
                      </Modal>
                    </div>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* ========== CANDIDATE SUBMISSIONS ACCORDION ========== */}
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <i className="fa fa-edit text-success mr-2"></i> Candidate
                Submissions
              </Accordion.Header>
              <Accordion.Body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="text-secondary mb-0">Submissions List</h5>
                  {submissions.length < 1 && (
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => {
                        setIsViewMode(false);
                        setIsEditing(false);
                        setShowSubmissionForm(true);
                        reset({
                          payRate: candidateDetails?.payRate || "",
                          jobRole: candidateDetails?.jobRole || "",
                          experience: candidateDetails?.experience || "",
                          vendor: "",
                          jobTitle: "",
                          clientStatus: "New",
                          documents: [],
                          customAssessmentLink: "",
                          skillMetrics: "",
                          technicalSkill:
                            candidateDetails?.technicalSkill || "",
                          ProfileSummery:
                            candidateDetails?.profileSummery || "",
                          Resume: candidateDetails?.resume || "",
                        });

                        if (candidateDetails?.experience) {
                          const exp =
                            candidateDetails.experience.match(
                              /(\d+)\s*Years?\s*(\d+)?\s*Months?/i
                            );
                          if (exp) {
                            const y = exp[1] || "0";
                            const m = exp[2] || "0";
                            setYears(y);
                            setMonths(m);
                            setValue(
                              "experience",
                              `${y} Years ${m} Months`
                            );
                          }
                        }

                        setUploadedFiles({
                          Resume:
                            candidateDetails?.fileUrl ||
                            candidateDetails?.resume ||
                            null,
                        });
                      }}
                    >
                      <i className="fa fa-plus mr-1"></i> Add Submission
                    </button>
                  )}
                </div>

                {submissions.length > 0 ? (
                  <div className="table-responsive">
                    <table
                      className="table"
                      style={{
                        fontSize: "12px",
                        wordWrap: "break-word",
                      }}
                    >
                      <thead className="table-light">
                        <tr>
                          <th>Vendor</th>
                          <th>Vendor Email</th>
                          <th>Job Title</th>
                          <th>Job Role</th>
                          <th>Client Status</th>
                          <th>Bill Rate</th>
                          <th>Pay Rate</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {submissions.map((s, i) => (
                          <tr key={i}>
                            <td>{s.vendorName}</td>
                            <td>{s.vendorEmail}</td>
                            <td>{s.jobTitle}</td>
                            <td>{s.jobRole}</td>
                            <td>{s.clientStatus}</td>
                            <td>{s.billRate}</td>
                            <td>{s.payRate}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-outline-success mr-2"
                                onClick={async () => {
                                  setIsEditing(true);
                                  setIsViewMode(false);
                                  setUploadedFiles({});
                                  await fetchJobRoles();
                                  await fetchSubmissionById(s.submissionGuid);
                                  setShowSubmissionForm(true);
                                }}
                              >
                                <i className="fa fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-outline-secondary mr-2"
                                onClick={async () => {
                                  setIsEditing(false);
                                  setIsViewMode(true);
                                  setUploadedFiles({});
                                  await fetchSubmissionById(s.submissionGuid);
                                  setShowSubmissionForm(true);
                                }}
                              >
                                <i className="fa fa-eye"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() =>
                                  handleDeleteSubmission(s.submissionGuid)
                                }
                              >
                                <i className="fa fa-trash "></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-muted">No submissions found.</p>
                )}

                {/* ======= ADD/EDIT/VIEW SUBMISSION MODAL ======= */}
                <Modal
                  show={showSubmissionForm}
                  onHide={() => setShowSubmissionForm(false)}
                  size="xl"
                  centered
                  dialogClassName="custom-modal-dialog"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {isViewMode
                        ? "View Submission"
                        : isEditing
                        ? "Edit Submission"
                        : "Add New Submission"}
                  </Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="custom-modal-body">
                    {isLoading ? (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: "100%" }}
                      >
                        <LoadingSpinner />
                      </div>
                    ) : (
                      <Form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                          {/* Vendor */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip">Select Vendor</Tooltip>
                              }
                            >
                              <div>
                                <Select
                                  options={vendorData.map((v) => ({
                                    value: v.vGuid,
                                    label: `${v.vendorName} - ${v.vendorCompanyName}`,
                                  }))}
                                  value={
                                    vendorData
                                      .map((v) => ({
                                        value: v.vGuid,
                                        label: `${v.vendorName} - ${v.vendorCompanyName}`,
                                      }))
                                      .find(
                                        (opt) =>
                                          opt.value === watch("VendorGuid")
                                      ) || null
                                  }
                                  onChange={(selected) =>
                                    setValue(
                                      "VendorGuid",
                                      selected?.value || ""
                                    )
                                  }
                                  placeholder="Select Vendor"
                                  isDisabled={isViewMode}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      borderRadius: 15,
                                      height: 50,
                                      fontSize: 12,
                                    }),
                                  }}
                                />
                                {errors.VendorGuid && (
                                  <span className="text-danger">
                                    Vendor is required
                                  </span>
                                )}
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Job Role */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip">
                                  Select Job Role
                                </Tooltip>
                              }
                            >
                              <div>
                                <Select
                                  options={jobRoles.map((j) => ({
                                    value: j.jobRoleId,
                                    label: j.jobRole,
                                  }))}
                                  value={
                                    jobRoles
                                      .map((j) => ({
                                        value: j.jobRoleId,
                                        label: j.jobRole,
                                      }))
                                      .find(
                                        (opt) =>
                                          opt.value === watch("jobRole")
                                      ) || null
                                  }
                                  onChange={(selected) =>
                                    setValue(
                                      "jobRole",
                                      selected?.value || ""
                                    )
                                  }
                                  placeholder="Select Job Role"
                                  isDisabled={isViewMode}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      borderRadius: 15,
                                      height: 50,
                                      fontSize: 12,
                                    }),
                                  }}
                                />
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Job Title */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip">
                                  Select Job Title
                                </Tooltip>
                              }
                            >
                              <div>
                                <Select
                                  options={jobPosts.map((job) => ({
                                    value: job.jobPostID,
                                    label: `${job.title} - ${job.clientName}`,
                                  }))}
                                  value={
                                    jobPosts
                                      .map((job) => ({
                                        value: job.jobPostID,
                                        label: `${job.title} - ${job.clientName}`,
                                      }))
                                      .find(
                                        (opt) =>
                                          opt.value ===
                                          (watch("jobPost") ||
                                            selectedJobTitleId)
                                      ) || null
                                  }
                                  onChange={(selected) => {
                                    const selectedOption = jobPosts.find(
                                      (j) => j.jobPostID === selected?.value
                                    );
                                    setValue(
                                      "jobPost",
                                      selected?.value || ""
                                    );
                                    setSelectedJobTitleId(
                                      selected?.value || ""
                                    );
                                    if (selectedOption) {
                                      const normalizedBill =
                                        selectedOption.billRate?.replace(
                                          /[^0-9.]/g,
                                          ""
                                        ) || "";
                                      const normalizedPay =
                                        selectedOption.payRate?.replace(
                                          /[^0-9.]/g,
                                          ""
                                        ) || "";
                                      setValue("BillRate", normalizedBill);
                                      setValue("payRate", normalizedPay);
                                    }
                                  }}
                                  placeholder="Select Job Title"
                                  isDisabled={isViewMode}
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      borderRadius: 15,
                                      height: 50,
                                      fontSize: 12,
                                    }),
                                  }}
                                />
                                {errors.jobPost && (
                                  <div className="invalid-feedback d-block">
                                    {errors.jobPost.message}
                                  </div>
                                )}
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Experience: Years / Months */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-years">
                                  Years of Experience
                                </Tooltip>
                              }
                            >
                              <div className="d-flex gap-2">
                                <select
                                  className={`form-control ${
                                    errors.experience ? "is-invalid" : ""
                                  }`}
                                  disabled={isViewMode}
                                  value={years}
                                  onChange={(e) =>
                                    handleExperienceChange(
                                      e.target.value,
                                      months
                                    )
                                  }
                                  style={{ height: 50, width: "50%" }}
                                >
                                  <option value="">Years</option>
                                  {[...Array(51).keys()].map((y) => (
                                    <option key={y} value={y}>
                                      {y}
                                    </option>
                                  ))}
                                </select>

                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-months">
                                      Months of Experience
                                    </Tooltip>
                                  }
                                >
                                  <select
                                    className={`form-control ${
                                      errors.experience ? "is-invalid" : ""
                                    }`}
                                    value={months}
                                    disabled={isViewMode}
                                    onChange={(e) =>
                                      handleExperienceChange(
                                        years,
                                        e.target.value
                                      )
                                    }
                                    style={{ height: 50, width: "50%" }}
                                  >
                                    <option value="">Months</option>
                                    {[...Array(12).keys()].map((m) => (
                                      <option key={m} value={m}>
                                        {m}
                                      </option>
                                    ))}
                                  </select>
                                </OverlayTrigger>
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Bill Rate */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={(props) => (
                                <Tooltip id="tooltip" {...props}>
                                  {selectedCountry == 2
                                    ? "Bill Rate"
                                    : "Expected CTC"}
                                </Tooltip>
                              )}
                            >
                              <div>
                                <input
                                  disabled={isViewMode}
                                  type={selectedCountry == 2 ? "number" : "text"}
                                  placeholder={
                                    selectedCountry == 2
                                      ? "Bill Rate"
                                      : "Expected CTC"
                                  }
                                  {...register("BillRate")}
                                  id="BillRate"
                                  name="BillRate"
                                  className="form-control basic-form"
                                  onChange={(e) => {
                                    const input = e.target.value;
                                    const cleaned =
                                      input.replace(/[^0-9.$Rs.]/gi, "");
                                    setValue("BillRate", cleaned);
                                  }}
                                />
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Pay Rate */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={(props) => (
                                <Tooltip id="tooltip" {...props}>
                                  {selectedCountry == 2
                                    ? "Pay Rate"
                                    : "Current CTC"}
                                </Tooltip>
                              )}
                            >
                              <div>
                                <input
                                  disabled={isViewMode}
                                  type={selectedCountry == 2 ? "number" : "text"}
                                  placeholder={
                                    selectedCountry == 2
                                      ? "Pay Rate"
                                      : "Current CTC"
                                  }
                                  {...register("payRate")}
                                  id="payRate"
                                  name="payRate"
                                  className="form-control basic-form"
                                  onChange={(e) => {
                                    const input = e.target.value;
                                    const cleaned =
                                      input.replace(/[^0-9.$Rs.]/gi, "");
                                    setValue("payRate", cleaned);
                                  }}
                                />
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Work Mode */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-workMode">
                                  Work Mode
                                </Tooltip>
                              }
                            >
                              <div>
                                <Form.Select
                                  disabled={isViewMode}
                                  {...register("workMode")}
                                  style={{
                                    height: 50,
                                    borderRadius: 15,
                                    fontSize: 12,
                                  }}
                                >
                                  <option value="">Select Work Mode</option>
                                  {workmode.map((w) => (
                                    <option
                                      key={w.statusID}
                                      value={w.statusName}
                                    >
                                      {w.statusName}
                                    </option>
                                  ))}
                                </Form.Select>
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Client Status */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-clientStatus">
                                  Client Status
                                </Tooltip>
                              }
                            >
                              <div>
                                <Form.Select
                                  disabled={isViewMode}
                                  {...register("clientStatus")}
                                  style={{
                                    height: 50,
                                    borderRadius: 15,
                                    fontSize: 12,
                                  }}
                                >
                                  <option value="">Select Status</option>
                                  <option value="Submitted">Submitted</option>
                                  <option value="Shortlisted">
                                    Shortlisted
                                  </option>
                                  <option value="Interview Scheduled">
                                    Interview Scheduled
                                  </option>
                                  <option value="Offered">Offered</option>
                                  <option value="Started">Started</option>
                                  <option value="Rejected">Rejected</option>
                                  <option value="Hold">Hold</option>
                                </Form.Select>
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Technical Skill */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-techSkill">
                                  Technical Skill
                                </Tooltip>
                              }
                            >
                              <div>
                                <input
                                  type="text"
                                  placeholder="Technical Skill"
                                  disabled={isViewMode}
                                  {...register("technicalSkill")}
                                  id="technicalSkill"
                                  name="technicalSkill"
                                  className="form-control basic-form"
                                />
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Profile Summary */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-profileSummary">
                                  Profile Summary
                                </Tooltip>
                              }
                            >
                              <div>
                                <textarea
                                  disabled={isViewMode}
                                  placeholder="Profile Summary"
                                  {...register("ProfileSummery")}
                                  id="ProfileSummery"
                                  name="ProfileSummery"
                                  className="form-control basic-form"
                                />
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Availability to Interview */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-avlInt">
                                  Availability for Interview
                                </Tooltip>
                              }
                            >
                              <input
                                type="text"
                                disabled={isViewMode}
                                placeholder="Availability for Interview"
                                {...register("AvailabilityToInterview")}
                                id="AvailabilityToInterview"
                                name="AvailabilityToInterview"
                                className="form-control basic-form mt-3"
                              />
                            </OverlayTrigger>
                          </div>

                          {/* Availability to Join */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-avlJoin">
                                  Availability for Joining
                                </Tooltip>
                              }
                            >
                              <input
                                type="text"
                                disabled={isViewMode}
                                placeholder="Availability for Joining"
                                {...register("AvailabilityToJoin")}
                                id="AvailabilityToJoin"
                                name="AvailabilityToJoin"
                                className="form-control basic-form mt-3"
                              />
                            </OverlayTrigger>
                          </div>

                          {/* Submitted By */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-submittedBy">
                                  Select Submitted By
                                </Tooltip>
                              }
                            >
                              <div>
                                <Select
                                  options={usersList.map((u) => ({
                                    value: u.email,
                                    label: u.fullName
                                      ? `${u.fullName} (${u.email})`
                                      : u.email,
                                  }))}
                                  isDisabled={isViewMode}
                                  value={
                                    usersList
                                      .map((u) => ({
                                        value: u.email,
                                        label: u.fullName
                                          ? `${u.fullName} (${u.email})`
                                          : u.email,
                                      }))
                                      .find(
                                        (opt) =>
                                          opt.value ===
                                          (watch("SubmittedBy") ||
                                            submittedBy)
                                      ) || null
                                  }
                                  onChange={(selected) => {
                                    setValue(
                                      "SubmittedBy",
                                      selected?.value || ""
                                    );
                                    setSubmittedBy(selected?.value || "");
                                  }}
                                />
                              </div>
                            </OverlayTrigger>
                          </div>

                          {/* Skill Metrics */}
                          <div className="col-md-6 mb-3">
                            <label
                              className=""
                              style={{ fontSize: "12px" }}
                            >
                              Skill Metrics
                            </label>
                            {skills.map((skill, index) => (
                              <div
                                key={index}
                                className="d-flex gap-2 mb-2 align-items-center mt-2"
                              >
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Skill"
                                  value={skill.Skill}
                                  disabled={isViewMode}
                                  onChange={(e) =>
                                    handleChangeSkill(
                                      index,
                                      "Skill",
                                      e.target.value
                                    )
                                  }
                                />
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="No.of Years Exp"
                                  value={skill.YearsOfExp}
                                  disabled={isViewMode}
                                  onChange={(e) =>
                                    handleChangeSkill(
                                      index,
                                      "YearsOfExp",
                                      e.target.value
                                    )
                                  }
                                />
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Rating (1-5)"
                                  min="1"
                                  max="5"
                                  value={skill.Rating}
                                  disabled={isViewMode}
                                  onChange={(e) =>
                                    handleChangeSkill(
                                      index,
                                      "Rating",
                                      e.target.value
                                    )
                                  }
                                />
                                {!isViewMode && (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={() =>
                                        handleDeleteSkill(index)
                                      }
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                    {index === skills.length - 1 && (
                                      <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={handleAddSkill}
                                      >
                                        <i className="fa fa-plus"></i>
                                      </button>
                                    )}
                                  </>
                                )}
                              </div>
                            ))}
                            <input
                              type="hidden"
                              {...register("SkillMetrics")}
                            />
                          </div>

                          {/* Comments (Quill) */}
                          {(isEditing || isViewMode) && (
                            <div className="col-md-6 mb-3">
                              <label style={{ fontSize: 12 }}>
                                Comments
                              </label>
                              <ReactQuill
                                theme="snow"
                                value={watch("Comments") || ""}
                                onChange={(value) =>
                                  setValue(
                                    "Comments",
                                    DOMPurify.sanitize(value)
                                  )
                                }
                                readOnly={isViewMode}
                                style={{
                                  height: "150px",
                                  marginBottom: "40px",
                                  background: isViewMode
                                    ? "#f5f5f5"
                                    : "white",
                                  borderRadius: "8px",
                                }}
                              />
                            </div>
                          )}

                          {/* Documents Upload */}
                          <div className="col-md-6 mb-3">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={(props) => (
                                <Tooltip id="tooltip-docs" {...props}>
                                  Upload Documents
                                </Tooltip>
                              )}
                            >
                              <div>
                                <Form.Select
                                  value={selectedDocType || ""}
                                  disabled={isViewMode}
                                  onChange={(e) =>
                                    setSelectedDocType(e.target.value)
                                  }
                                  style={{
                                    height: 50,
                                    borderRadius: 15,
                                    fontSize: 12,
                                    borderColor: errors.jobPost
                                      ? "red"
                                      : "",
                                  }}
                                >
                                  <option value="">
                                    Select Any Document
                                  </option>
                                  {documents.map((doc, idx) => (
                                    <option
                                      key={idx}
                                      value={doc.documentType}
                                    >
                                      {doc.documentType}
                                    </option>
                                  ))}
                                </Form.Select>

                                {selectedDocType && !isViewMode && (
                                  <div className="mt-1">
                                    <Form.Label
                                      htmlFor="uploadFile"
                                      className="fw-bold"
                                    >
                                      Attach {selectedDocType}
                                    </Form.Label>
                                    <Form.Control
                                      type="file"
                                      id="uploadFile"
                                      accept=".pdf,doc,docx,jpg,jpeg,png"
                                      onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (!file) return;
                                        const updatedFiles = {
                                          ...uploadedFiles,
                                          [selectedDocType]: file,
                                        };
                                        setUploadedFiles(updatedFiles);
                                        e.target.value = "";
                                      }}
                                    />
                                  </div>
                                )}

                                {/* Existing docs list */}
                                <div className="mt-2">
                                  {Object.keys(uploadedFiles).map(
                                    (docTypeKey) => {
                                      const file = uploadedFiles[docTypeKey];
                                      if (!file) return null;

                                      const isFileObject =
                                        file instanceof File;
                                      const isString =
                                        typeof file === "string";
                                      const isInvalidString =
                                        isString &&
                                        (file.trim() === "" ||
                                          file
                                            .trim()
                                            .toLowerCase() === "null" ||
                                          file
                                            .trim()
                                            .toLowerCase() ===
                                            "undefined" ||
                                          file.endsWith("/") ||
                                          file.endsWith("/null") ||
                                          file.endsWith("/undefined"));

                                      if (isInvalidString) return null;

                                      const displayLabel =
                                        documentLabels[docTypeKey] ||
                                        docTypeKey;
                                      const isValidUrl =
                                        isString && !isInvalidString;
                                      const fileName = isValidUrl
                                        ? file.split("/").pop()
                                        : file.name;

                                      return (
                                        <div key={docTypeKey}>
                                          <strong style={{ fontSize: 12 }}>
                                            {displayLabel} :
                                          </strong>
                                          &nbsp;
                                          <span style={{ fontSize: 12 }}>
                                            {fileName}
                                          </span>
                                          &nbsp;|&nbsp;
                                          <button
                                            type="button"
                                            style={{
                                              border: "none",
                                              background: "transparent",
                                              color: "blue",
                                              fontSize: 12,
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              handleShowModal1(
                                                docTypeKey,
                                                file
                                              )
                                            }
                                          >
                                            View
                                          </button>
                                          {!isViewMode && (
                                            <>
                                              &nbsp; | &nbsp;
                                              <button
                                                type="button"
                                                style={{
                                                  border: "none",
                                                  background: "transparent",
                                                  color: "red",
                                                  fontSize: 12,
                                                  cursor: "pointer",
                                                }}
                                                onClick={() =>
                                                  handleRemoveFile(
                                                    docTypeKey
                                                  )
                                                }
                                              >
                                                Remove
                                              </button>
                                            </>
                                          )}
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </OverlayTrigger>
                          </div>
                        </div>

                        <div className="text-end mt-3">
                          {!isViewMode && (
                            <Button type="submit" className="btn btn-success">
                              <i className="fa fa-check mr-1"></i>
                              {isEditing ? "Update" : "Submit"}
                            </Button>
                          )}
                        </div>
                      </Form>
                    )}
                  </Modal.Body>
                </Modal>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      ) : (
        <center>
          <LoadingSpinner />
        </center>
      )}

      {/* Document preview modal (for upload section) */}
      <Modal
        show={showModal1}
        onHide={handleCloseModal1}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalContent.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {renderAttachment(
            modalContent.url,
            modalContent.file,
            modalContent.html
          )}
        </Modal.Body>
      </Modal>

      {/* Assessment mode modal (if you use it) */}
      <Modal
        show={showAssessmentModal}
        onHide={() => setShowAssessmentModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Custom Assessment Link</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!assessmentMode && (
            <div className="d-flex flex-column gap-3">
              <button
                className="btn btn-outline-primary"
                onClick={() => setAssessmentMode("link")}
              >
                Enter Link Directly
              </button>
              <button
                className="btn btn-outline-secondary"
                onClick={() => setAssessmentMode("file")}
              >
                Upload File
              </button>
            </div>
          )}

          {assessmentMode === "link" && (
            <input
              type="text"
              className="form-control"
              placeholder="Enter Custom Assessment Link"
              {...register("customAssessmentLink")}
            />
          )}

          {assessmentMode === "file" && (
            <input
              type="file"
              accept="audio/*,pdf,doc,docx,video/mp4,video/webm"
              className="form-control"
              onChange={(e) => setAssessmentFile(e.target.files[0])}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => {
              setAssessmentMode("");
              setShowAssessmentModal(false);
            }}
          >
            Close
          </button>
          <button
            className="btn btn-primary"
            onClick={() => setShowAssessmentModal(false)}
          >
            Done
          </button>
        </Modal.Footer>
      </Modal>
    </ConsultantLayout>
  );
};







export default ViewAppliedCandidateDetailsbyId;





